import React from 'react';
import {makeStyles} from '@rneui/themed';

import Button from '../../../components/themed/Button';
import Text from '../../../components/themed/Text';
import {useStores} from '../../../stores/use-stores';

type CartCouponProps = {
  onCouponPress?: any;
};

function CartCoupon({onCouponPress}: CartCouponProps) {
  const {cartStore} = useStores();
  const styles = useStyles();

  return (
    <Button
      containerStyle={{marginVertical: 0}}
      buttonStyle={{justifyContent: 'space-between'}}
      variant="text"
      onPress={onCouponPress}
      iconRight
      icon={{name: !!cartStore.currentOrder?.coupon_code ? 'edit' : 'add'}}>
      {!!cartStore.currentOrder?.coupon_code && (
        <Text adjustsFontSizeToFit numberOfLines={1} style={styles.secondLine}>
          {cartStore.currentOrder?.coupon_code}
        </Text>
      )}
      {!cartStore.currentOrder?.coupon_code && (
        <Text style={styles.couponText}>ADD COUPON</Text>
      )}
    </Button>
  );
}

const useStyles = makeStyles(theme => {
  return {
    couponText: {
      color: theme.colors?.legacy?.text?.heading?.primary,
      fontWeight: '600',
      fontSize: 16,
      textAlign: 'center',
    },
    secondLine: {
      color: theme.colors?.legacy?.text?.heading?.primary,
      fontWeight: '600',
      fontSize: 16,
      textAlign: 'center',
    },
  };
});

export default CartCoupon;
